// extracted by mini-css-extract-plugin
module.exports = {"ContentFullScreen2":"ContentFullScreen2_ContentFullScreen2__l8s_K","bgImage":"ContentFullScreen2_bgImage__6NYgU"};